/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Segment, Dimmer, Loader, Button, List } from 'semantic-ui-react';
import { DoctorInfoComponent } from './doctorInfo/doctorInfo.component';
import { fetchAllDoctorsCall } from '../../utils/apiCalls';

export default function DoctorsComponent() {
  const [doctors, setDoctors] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isDoctorSelected, setIsDoctorSelected] = useState(false);
  const [selectedDoctor, setSelectedDoctor] = useState({});

  const handleBackToList = () => {
    setIsDoctorSelected(false);
  };

  useEffect(() => {
    const loadDoctors = async () => {
      setIsLoading(true);
      const response = await fetchAllDoctorsCall();

      if (response && response.data) {
        setDoctors(response.data);
      } else {
        console.error('Failed to fetch doctors:', response);
        setDoctors([]);
      }
      setIsLoading(false);
    };

    loadDoctors();
  }, []);

  const onSelectDoctor = (item: any) => {
    setSelectedDoctor(item);
    setIsDoctorSelected(true);
  };

  const renderDoctorsList = (doctorsList: any) =>
    doctorsList.map((item: any, i: number) => (
      <Segment.Group horizontal key={i}>
        <Segment raised inverted className='segment-style' style={{ flex: 3 }}>
          <List>
            <List.Item>
              {/* FIX: Combine firstname and lastname to show the full name */}
              Name: <b>{`${item.firstname} ${item.lastname}`}</b>
            </List.Item>
            <List.Item>Email: {item.email || '-'}</List.Item>
            <List.Item>ID: {item.id}</List.Item>
          </List>
        </Segment>
        <Segment raised inverted className='segment-style verticalCenter' textAlign='right' style={{ flex: 1 }}>
          <Button onClick={() => onSelectDoctor(item)} primary floated='right'>
            Details
          </Button>
        </Segment>
      </Segment.Group>
    ));

  const doctorsListLoading = (
    <Dimmer active inverted>
      <Loader className='loading-spinner' active inline='centered'>
        <FormattedMessage id='loading' />
      </Loader>
    </Dimmer>
  );

  return (
    <div className='details_container'>
      {!isDoctorSelected ? (
        <div>{isLoading ? doctorsListLoading : renderDoctorsList(doctors)}</div>
      ) : (
        <DoctorInfoComponent selectedDoctor={selectedDoctor} onBack={handleBackToList} />
      )}
    </div>
  );
}
